import { LinkButton } from '@/components/primitives/Button';
import { cn } from '@/lib/cn';
import { ROUTES } from '@/lib/routes';
import type { Audience } from './AudienceFields';

export type { Audience };

/**
 * El bloque que hasta ahora era el alta en la lista de espera.
 *
 * El formulario pedía email, jurisdicción, institución y rol, no enviaba nada a
 * ningún lado, y respondía "Te anotamos en la lista de espera": cierto en la
 * pantalla y falso en los hechos. Era la afirmación sin respaldo más lisa que
 * quedaba en el repositorio, y en una página pública.
 *
 * Que la lista guarde de verdad ya está decidido (019 E1, decisión 4) y lo que
 * falta no es front. `docs/legal/privacy.md` declara hoy que SICA no pide email
 * ni ningún dato identificatorio, tiene regla de no-drift sobre sus dos
 * superficies publicadas, y su responsable del tratamiento sigue siendo un
 * placeholder pendiente de ratificación. Guardar un email antes de resolver eso
 * expone a la persona en vez de adelantar trabajo.
 *
 * Mientras tanto la pantalla dice lo que hace, y ofrece la puerta que sí existe.
 */
export function WaitlistForm({
  audience,
  className,
}: {
  audience: Audience;
  className?: string;
}) {
  return (
    <div
      className={cn('rounded-lg border border-line bg-paper-tinted/40 p-6', className)}
      data-audience={audience}
    >
      <p className="font-serif text-lg text-ink">Todavía no tenemos lista de espera abierta.</p>
      <p className="mt-3 text-base leading-relaxed text-ink-muted">
        Cuando la abramos vamos a decirte qué guardamos, para qué, cuánto tiempo y cómo pedir que lo
        borremos. Hasta entonces preferimos no pedirte un dato que no podemos cuidar como
        corresponde.
      </p>
      <p className="mt-4 text-base leading-relaxed text-ink-muted">
        Mientras tanto podés ver la cobertura de tu jurisdicción, que sale medida del inventario
        curricular y cambia a medida que sumamos diseños.
      </p>
      <div className="mt-5">
        <LinkButton href={ROUTES.producto.jurisdicciones} variant="primary">
          Ver la cobertura
        </LinkButton>
      </div>
    </div>
  );
}
